const defaultFoundationLight = {
  primary: '#0022CC',
  success: '#0C6E22',
  info: '#6E0A87',
  warning: '#FF6F00',
  critical: '#E4130C',
  secondary: '#0F2A46',
  accent: '#524834'
};
const defaultFoundationMuted = {
  primary: '#1C1C1B',
  success: '#0C6E22',
  info: '#6E0A87',
  warning: '#FF6F00',
  critical: '#E4130C',
  secondary: '#0F2A46',
  accent: '#524834'
};
const defaultFoundationDark = {
  primary: '#7486DC',
  success: '#52A075',
  info: '#AF80BE',
  warning: '#C98104',
  critical: '#F16251',
  secondary: '#0F2A46',
  accent: '#a29b8d'
};
function colorsFromFoundationContrast(foundation) {
  return {
    primary: foundation.primary,
    secondary: foundation.secondary,
    accent: foundation.accent || '',
    success: foundation.success,
    info: foundation.info,
    warning: foundation.warning,
    critical: foundation.critical
  };
}
function colorsFromFoundation(foundationLight, foundationDark, foundationMuted) {
  return {
    light: colorsFromFoundationContrast(foundationLight !== null && foundationLight !== void 0 ? foundationLight : defaultFoundationLight),
    dark: colorsFromFoundationContrast(foundationDark !== null && foundationDark !== void 0 ? foundationDark : defaultFoundationDark),
    muted: colorsFromFoundationContrast(foundationMuted !== null && foundationMuted !== void 0 ? foundationMuted : defaultFoundationMuted)
  };
}

export { colorsFromFoundation };
